module.exports = __webpack_public_path__ + "static/media/80Hou@4x.1cc4d302.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/80Hou@4x.png
// module id = 1693
// module chunks = 0 1